/* Product Form Submit Handler (Ajax) */

customElements.define(
  "product-form",
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.formElement = this.querySelector("form");
      this.formElement.addEventListener(
        "submit",
        this.onSubmitHandler.bind(this)
      );

      // Theres some odd behaviour with boost, where the submit event isnt running when you click the submit button. This way we manually dispatch the submit event only on boost buttons.
      const boostOverrideBtn = this.formElement.querySelector(
        ".product-card__submit--boost-override"
      );
      boostOverrideBtn?.addEventListener("click", (evt) => {
        this.formElement.dispatchEvent(new Event("submit"));
      });
    }

    getSectionsToRender() {
      return [
        {
          id: "cart-outer",
          section: "cart-items",
          selector: ".cart__cart-items",
        },
        {
          id: "cart-outer",
          section: "cart-summary",
          selector: ".cart__summary-outer",
        },
        {
          id: "cart-drawer",
          section: "cart-items",
          selector: ".cart__cart-items",
        },
        {
          id: "cart-drawer",
          section: "cart-footer",
          selector: ".cart-drawer__footer",
        },
        {
          id: "cart-drawer",
          section: "cart-upsells",
          selector: ".cart-drawer__upsells",
        },
        {
          id: "nav-inner",
          section: "cart-nav-icon",
          selector: ".nav__link--cart",
        },
      ];
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      const formData = new FormData(this.formElement);
      const sections = this.getSectionsToRender().map(
        (section) => section.section
      );
      const sectionsUrl = window.location.pathname;

      formData.append("sections", sections);
      formData.append("sections_url", sectionsUrl);

      config.body = formData;

      // Step 1: Add to cart
      fetch("/cart/add.json", config)
        .then(
          (response) => {
            if (response.ok) return response.json();
            throw new Error("Request Failed!");
          },
          (networkError) => console.log(networkError.message)
        )

        // Step 2: Run promo logic
        // .then(() => updateCartForPromotion())

        // Step 3: Re-fetch cart sections after promo update
        .then(() => {
          return fetch(
            `/?sections=${sections.join(",")}&sections_url=${sectionsUrl}`
          ).then((res) => res.json());
        })
        // Step 4: Update DOM
        .then((sectionHtml) => {
          this.getSectionsToRender().forEach((section) => {
            const container = document.getElementById(section.id);
            if (!container) return;

            const inner =
              container.querySelector(section.selector) || container;
            inner.innerHTML = this.getSectionInnerHTML(
              sectionHtml[section.section],
              section.selector
            );
            cartDrawerOpen();
          });
        })

        .catch((e) => {
          console.error(e);
        });
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }
  }
);

/* Quick Add Popup Controls */

quickAddOpen = (btn) => {
  btn
    .closest(".product-card")
    .querySelector("product-form")
    .classList.add("is-open");
  btn
    .closest(".product-card")
    .querySelector(".product__options-container-inner")
    .classList.add("is-visible");
  btn
    .closest(".product-card")
    .querySelector(".product-card__details-container")
    .classList.add("quickadd-is-open");
};

quickAddClose = (btn) => {
  btn
    .closest(".product-card")
    .querySelector("product-form")
    .classList.remove("is-open");
  btn
    .closest(".product-card")
    .querySelector(".quick-add__label--back").style.display = "none";
  btn
    .closest(".product-card")
    .querySelector(".product-card__details-container")
    .classList.remove("quickadd-is-open");

  var productOptionContainers = document.querySelectorAll(
    ".product__options-container-inner"
  );
  productOptionContainers.forEach((container) => {
    container.classList.remove("is-visible");
  });
};

quickAddBack = (btn) => {
  var currentOptionContainer = btn
      .closest(".product-card")
      .querySelectorAll(".product__options-container-inner.is-visible"),
    currentOptionContainer =
      currentOptionContainer[currentOptionContainer.length - 1];

  console.log(currentOptionContainer);
  currentOptionContainer.classList.remove("is-visible");
  if (currentOptionContainer.previousSibling.classList.contains("is-first")) {
    btn.style.display = "none";
  }
};

quickAddController = (btn) => {
  var optionContainer = btn.closest(".product__options-container-inner");

  if (optionContainer.classList.contains("is-last")) {
    optionContainer
      .closest("form")
      .querySelector(".product-form__submit")
      .click();
    setTimeout(() => {
      quickAddClose(btn);
    }, 300);
  } else {
    optionContainer.nextSibling.classList.add("is-visible");
    optionContainer
      .closest(".product-card")
      .querySelector(".quick-add__label--back").style.display = "block";
  }
};

function updateCartForPromotion() {
  return fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      const total = cart.items_subtotal_price;
      const lastItem = cart.items[cart.items.length - 1];
      const promoKey = "Contains";
      const promoValue = "FREE INFRARED PATIO HEATER INCLUDED WITH THIS ORDER!";

      if (!lastItem) return Promise.resolve(); // ✅ Return a resolved promise

      const hasPromo =
        lastItem.properties && lastItem.properties[promoKey] === promoValue;
      const needsPromo = total > 49999;

      if (needsPromo && !hasPromo) {
        const newProps = { ...(lastItem.properties || {}) };
        newProps[promoKey] = promoValue;

        return fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: lastItem.key,
            quantity: lastItem.quantity,
            properties: newProps,
          }),
        });
      }

      if (!needsPromo && hasPromo) {
        const newProps = { ...lastItem.properties };
        delete newProps[promoKey];

        return fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: lastItem.key,
            quantity: lastItem.quantity,
            properties: newProps,
          }),
        });
      }

      return Promise.resolve(); // ✅ Important: always return a promise
    })
    .catch((err) => {
      console.error("Promotion update failed:", err);
      return Promise.resolve(); // Still resolve to avoid breaking the chain
    });
}
